import script from "./RoomPublic.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomPublic.vue?vue&type=script&setup=true&lang=js"

import "./RoomPublic.vue?vue&type=style&index=0&id=e28dd200&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e28dd200"]])

export default __exports__